import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ShopListItemContainer from '../containers/ShopListItemContainer';
import Text from '../containers/Text';
import Message from './Message';

export const ShopList = ({shops, isFetching, sortCode1, showSearchDetails}) => {
  let shopList = shops.map(shop => {
    if (sortCode1 && sortCode1 !== shop.sortCode1) {
    } else {
      return <ShopListItemContainer key={shop.parcelShopNumber} shop={shop} />
    }
  });

  shopList = shopList.filter(item => item !== undefined);

  return (
    <div className={`shop-list ${isFetching ? 'is-fetching' : ''} ${showSearchDetails || isFetching ? 'open' : 'closed'}`}>
      <Message />

      {shops.length > 0 ? (
        <div className="shop-list__list-wrapper">
            {shopList.length > 0 ? (
              <ul id="selenium-test-shop-list-results" className="shop-list__list">
                {shopList}
              </ul>
            ) : (
              <p className="alert alert-danger m-md">
                <Text id='shoplist.no-reroute-shops' />
              </p>
            )}
        </div>
      ) : null}
    </div>
  );
};

ShopList.propTypes = {
  shops: PropTypes.array.isRequired
};

const mapStateToProps = ({search}) => ({
    showSearchDetails: search.showSearchDetails
  });

export default connect(mapStateToProps)(ShopList);
